/*
 * Woolie — Revenda: formulário de cadastro de empresa (portão da /pages/revenda).
 * O form é o 'contact' nativo da Shopify (vai por e-mail pra loja; cria o cliente
 * com a tag cadastro-revenda).
 *
 * Parte 1 — blocos dinâmicos: endereços de entrega (até 3) e contatos (até 3) já
 * vêm prontos no HTML, escondidos e com inputs disabled — input disabled não é
 * validado nem enviado. Aqui só se revela/esconde e liga/desliga o required
 * (campos marcados com data-req). Sem innerHTML/clonagem.
 *
 * Parte 2 — enriquecimento por API (progressivo; se a API cair, o form segue manual):
 *  - CNPJ: máscara + validação dos dígitos verificadores (offline, bloqueia submit
 *    de CNPJ inválido via setCustomValidity) + consulta à BrasilAPI (Receita,
 *    pública/sem chave/CORS *) → autopreenche razão social, fantasia e endereço de
 *    faturamento (só campos VAZIOS — nunca sobrescreve o que a pessoa digitou) e
 *    grava a situação cadastral num hidden que vai junto no e-mail do cadastro.
 *  - CEP (faturamento e entregas): máscara + ViaCEP → autopreenche rua/bairro/
 *    cidade/UF do MESMO bloco (data-addr agrupa; data-addr-role identifica).
 */
(function () {
  /* ============ helpers puros ============ */
  function digits(s) { return (s || '').replace(/\D+/g, ''); }
  function maskCNPJ(v) {
    v = digits(v).slice(0, 14);
    return v
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }
  function maskCEP(v) {
    v = digits(v).slice(0, 8);
    return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
  }
  // Dígitos verificadores do CNPJ (módulo 11).
  function validCNPJ(c) {
    c = digits(c);
    if (c.length !== 14 || /^(\d)\1+$/.test(c)) return false;
    function dv(base) {
      var w = base.length === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      var s = 0;
      for (var i = 0; i < base.length; i++) s += base[i] * w[i];
      var r = s % 11;
      return r < 2 ? 0 : 11 - r;
    }
    var n = c.split('').map(Number);
    return dv(n.slice(0, 12)) === n[12] && dv(n.slice(0, 13)) === n[13];
  }
  function fetchJson(url, ms) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var t = ctrl ? setTimeout(function () { ctrl.abort(); }, ms || 7000) : null;
    return fetch(url, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) {
        if (t) clearTimeout(t);
        if (!r.ok) throw { status: r.status };
        return r.json();
      })
      .catch(function (e) { if (t) clearTimeout(t); throw e; });
  }
  // Preenche um campo SÓ se estiver vazio (nunca sobrescreve o usuário).
  function fillIfEmpty(el, value) {
    if (!el || !value) return;
    if (el.tagName === 'SELECT') { if (!el.value) el.value = value; return; }
    if (!el.value.trim()) el.value = value;
  }

  function init() {
    var form = document.getElementById('cf-reg-form');
    if (!form) return;

    /* ============ Parte 1: blocos dinâmicos ============ */
    function setOn(block, on) {
      block.hidden = !on;
      var els = block.querySelectorAll('input,select,textarea');
      Array.prototype.forEach.call(els, function (el) {
        el.disabled = !on;
        if (el.hasAttribute('data-req')) el.required = on;
        if (!on) {
          if (el.type === 'checkbox') el.checked = false;
          else el.value = '';
          if (el.tagName === 'SELECT') el.selectedIndex = 0;
        }
      });
    }

    var same = form.querySelector('[data-reg-same]');
    var addrs = Array.prototype.slice.call(form.querySelectorAll('[data-reg-addr]'));
    var addAddr = form.querySelector('[data-reg-add-addr]');
    var people = Array.prototype.slice.call(form.querySelectorAll('[data-reg-person]'));
    var addPerson = form.querySelector('[data-reg-add-person]');

    function hiddenOnes(list) { return list.filter(function (b) { return b.hidden; }); }
    function syncButtons() {
      if (addAddr) addAddr.hidden = (same && same.checked) || hiddenOnes(addrs).length === 0;
      if (addPerson) addPerson.hidden = hiddenOnes(people).length === 0;
    }

    if (same) {
      same.addEventListener('change', function () {
        if (same.checked) {
          addrs.forEach(function (b) { setOn(b, false); });
        } else if (hiddenOnes(addrs).length === addrs.length) {
          setOn(addrs[0], true);
        }
        syncButtons();
      });
    }
    if (addAddr) {
      addAddr.addEventListener('click', function () {
        var next = hiddenOnes(addrs)[0];
        if (next) setOn(next, true);
        syncButtons();
      });
    }
    if (addPerson) {
      addPerson.addEventListener('click', function () {
        var next = hiddenOnes(people)[0];
        if (next) setOn(next, true);
        syncButtons();
      });
    }
    form.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-reg-rm]') : null;
      if (!btn) return;
      var block = btn.closest('[data-reg-addr], [data-reg-person]');
      if (!block) return;
      setOn(block, false);
      if (same && block.hasAttribute('data-reg-addr') && hiddenOnes(addrs).length === addrs.length) {
        same.checked = true;
      }
      syncButtons();
    });
    syncButtons();

    /* ============ Parte 2: CNPJ (Receita) + CEP (ViaCEP) ============ */
    var cnpjInput = form.querySelector('[data-reg-cnpj]');
    var cnpjHint = form.querySelector('[data-reg-cnpj-hint]');
    var receitaField = form.querySelector('[data-reg-receita]');

    function hint(msg, cls) {
      if (!cnpjHint) return;
      cnpjHint.textContent = msg || '';
      cnpjHint.hidden = !msg;
      cnpjHint.className = 'cf-reg__hint' + (cls ? ' cf-reg__hint--' + cls : '');
    }
    function addrEl(group, role) {
      return form.querySelector('[data-addr="' + group + '"][data-addr-role="' + role + '"]');
    }

    if (cnpjInput) {
      cnpjInput.addEventListener('input', function () {
        cnpjInput.value = maskCNPJ(cnpjInput.value);
        cnpjInput.setCustomValidity('');
        hint('');
      });
      cnpjInput.addEventListener('blur', function () {
        var c = digits(cnpjInput.value);
        if (!c) { hint(''); return; }
        if (!validCNPJ(c)) {
          cnpjInput.setCustomValidity('CNPJ inválido — confira os dígitos.');
          hint('CNPJ inválido — confira os dígitos.', 'err');
          return;
        }
        cnpjInput.setCustomValidity('');
        hint('Consultando a Receita…');
        fetchJson('https://brasilapi.com.br/api/cnpj/v1/' + c, 7000)
          .then(function (d) {
            fillIfEmpty(form.querySelector('[data-reg-fill="razao"]'), d.razao_social);
            fillIfEmpty(form.querySelector('[data-reg-fill="fantasia"]'), d.nome_fantasia);
            fillIfEmpty(addrEl('fat', 'cep'), maskCEP(d.cep || ''));
            fillIfEmpty(addrEl('fat', 'end'), d.logradouro);
            fillIfEmpty(addrEl('fat', 'num'), d.numero);
            fillIfEmpty(addrEl('fat', 'comp'), (d.complemento || '').slice(0, 60));
            fillIfEmpty(addrEl('fat', 'bairro'), d.bairro);
            fillIfEmpty(addrEl('fat', 'cidade'), d.municipio);
            fillIfEmpty(addrEl('fat', 'uf'), d.uf);
            if (receitaField) {
              receitaField.disabled = false;
              receitaField.value = (d.razao_social || '') +
                ' · situação: ' + (d.descricao_situacao_cadastral || '?') +
                ' · ' + (d.municipio || '') + '/' + (d.uf || '') +
                (d.cnae_fiscal_descricao ? ' · CNAE: ' + d.cnae_fiscal_descricao : '') +
                ' · fonte: BrasilAPI/Receita';
            }
            if (d.descricao_situacao_cadastral === 'ATIVA') {
              hint('✓ ' + (d.razao_social || 'Empresa encontrada') + ' — ATIVA na Receita. Endereço preenchido.', 'ok');
            } else {
              hint('Situação na Receita: ' + (d.descricao_situacao_cadastral || 'desconhecida') + ' — confira o CNPJ.', 'err');
            }
          })
          .catch(function (e) {
            if (e && e.status === 404) {
              hint('CNPJ não encontrado na Receita — confira o número.', 'err');
            } else {
              hint('Não deu pra consultar a Receita agora — pode continuar preenchendo normalmente.');
            }
          });
      });
    }

    // CEP → ViaCEP em qualquer bloco de endereço (faturamento e entregas).
    var cepInputs = Array.prototype.slice.call(form.querySelectorAll('[data-addr-role="cep"]'));
    cepInputs.forEach(function (cep) {
      cep.addEventListener('input', function () { cep.value = maskCEP(cep.value); });
      cep.addEventListener('blur', function () {
        var c = digits(cep.value);
        if (c.length !== 8) return;
        var group = cep.getAttribute('data-addr');
        (window.WoolieCep ? window.WoolieCep.consultar(c) : fetchJson('https://viacep.com.br/ws/' + c + '/json/', 6000))
          .then(function (d) {
            if (d.erro || digits(cep.value) !== c) return;
            fillIfEmpty(addrEl(group, 'end'), d.logradouro);
            fillIfEmpty(addrEl(group, 'bairro'), d.bairro);
            fillIfEmpty(addrEl(group, 'cidade'), d.localidade);
            fillIfEmpty(addrEl(group, 'uf'), d.uf);
          })
          .catch(function () { /* silencioso: preenchimento manual segue normal */ });
      });
    });

    /* ============ Parte 3: cria a Empresa antes de mandar o e-mail ============ */
    /*
      O envio nativo do {% form 'contact' %} continua sendo o caminho de baixo:
      ele SÓ é dispensado quando a API responde ok. Qualquer outra coisa (rede
      caiu, servidor fora, CNPJ recusado no servidor) deixa o formulário seguir
      como sempre seguiu, e o lead chega por e-mail. Nunca perder o cadastro vale
      mais que criar a empresa.
    */
    // Vem do editor de temas (ver o schema da seção). Vazio = nem tenta.
    var API = form.getAttribute('data-api') || '';

    function campo(nome) {
      var el = form.querySelector('[name="contact[' + nome + ']"]');
      return el && !el.disabled ? String(el.value || '').trim() : '';
    }
    function marcado(nome) {
      var el = form.querySelector('[name="contact[' + nome + ']"]');
      return !!(el && !el.disabled && el.checked);
    }
    function endereco(prefixo) {
      var cep = campo(prefixo + ' — CEP');
      if (!cep) return null;
      return {
        cep: cep,
        endereco: campo(prefixo + ' — Endereço'),
        numero: campo(prefixo + ' — Número'),
        complemento: campo(prefixo + ' — Complemento'),
        bairro: campo(prefixo + ' — Bairro'),
        cidade: campo(prefixo + ' — Cidade'),
        uf: campo(prefixo + ' — UF')
      };
    }
    function contatos() {
      var out = [];
      for (var i = 1; i <= 3; i++) {
        var nome = campo('Contato ' + i + ' — Nome');
        var email = campo('Contato ' + i + ' — E-mail');
        if (!nome || !email) continue;
        out.push({
          nome: nome,
          cargo: campo('Contato ' + i + ' — Cargo'),
          email: email,
          telefone: campo('Contato ' + i + ' — Telefone'),
          whatsapp: campo('Contato ' + i + ' — WhatsApp')
        });
      }
      return out;
    }
    function payload() {
      // "Entregar no mesmo endereço" marcado => os blocos de entrega estão
      // disabled, então endereco('Entrega 1') devolve null e o servidor usa só o
      // de faturamento. É o mesmo estado que decide o que vai no e-mail.
      return {
        razao_social: campo('Razão social'),
        nome_fantasia: campo('Nome fantasia'),
        cnpj: campo('CNPJ'),
        inscricao_estadual: campo('Inscrição Estadual'),
        consulta_receita: campo('Consulta Receita (automática)'),
        observacoes: campo('Observações'),
        instagram_site: campo('Instagram/site'),
        petshop: marcado('Petshop'),
        loja_fisica: marcado('Loja física'),
        venda_online: marcado('Venda online'),
        faturamento: endereco('Faturamento'),
        entrega: endereco('Entrega 1'),
        contatos: contatos()
      };
    }

    var enviando = false;
    form.addEventListener('submit', function (e) {
      if (!API) return;                  // sem API configurada: e-mail de sempre
      if (enviando) return;              // 2ª passagem: deixa o envio nativo ir
      if (!form.checkValidity()) return; // o próprio browser barra e aponta o campo
      e.preventDefault();
      enviando = true;

      var botao = form.querySelector('.cf-reg__submit');
      var rotulo = botao ? botao.textContent : '';
      if (botao) { botao.disabled = true; botao.textContent = 'Enviando…'; }

      var solta = function () {
        if (botao) { botao.disabled = false; botao.textContent = rotulo; }
        form.submit();  // .submit() não dispara o evento de novo, mas a trava fica
      };

      var timeout = setTimeout(solta, 9000);   // servidor lento não trava a pessoa
      var respondido = false;

      fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload())
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (d) {
          if (respondido) return;
          respondido = true;
          clearTimeout(timeout);
          if (d && d.ok) {
            // Deu certo: a empresa existe no admin. Marca no e-mail para quem
            // recebe saber que não precisa cadastrar à mão.
            var flag = document.createElement('input');
            flag.type = 'hidden';
            flag.name = 'contact[Empresa criada automaticamente]';
            flag.value = d.jaExistia ? 'Já existia com esse CNPJ' : 'Sim';
            form.appendChild(flag);
          }
          solta();
        })
        .catch(function () {
          if (respondido) return;
          respondido = true;
          clearTimeout(timeout);
          solta();
        });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
